import i18next from "i18next";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getCurrentLanguage, getLanguageWithCountry } from "src/utils/BasePathTools";

export const UpdateLanguage: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    const syncLanguage = async () => {
      const lang = getCurrentLanguage();
      if (i18next.language !== lang) {
        await i18next.changeLanguage(lang);
      }
      document.documentElement.lang = getLanguageWithCountry();
    };
    syncLanguage();
  }, [location]);

  return null;
};
